export const GET_BILLING_SUBSCRIPTION_REQUEST =
  "GET_BILLING_SUBSCRIPTION_REQUEST";
export const GET_BILLING_SUBSCRIPTION_SUCCESS =
  "GET_BILLING_SUBSCRIPTION_SUCCESS";
export const GET_BILLING_SUBSCRIPTION_FAIL = "GET_BILLING_SUBSCRIPTION_FAIL";
export const RESET_BILLING_SUBSCRIPTION = "RESET_BILLING_SUBSCRIPTION";

export const CREATE_BILLING_SUBSCRIPTION_REQUEST =
  "CREATE_BILLING_SUBSCRIPTION_REQUEST";
export const CREATE_BILLING_SUBSCRIPTION_SUCCESS =
  "CREATE_BILLING_SUBSCRIPTION_SUCCESS";
export const CREATE_BILLING_SUBSCRIPTION_FAIL =
  "CREATE_BILLING_SUBSCRIPTION_FAIL";
export const RESET_CREATE_BILLING_SUBSCRIPTION =
  "RESET_CREATE_BILLING_SUBSCRIPTION";

export const UPDATE_BILLING_SUBSCRIPTION_REQUEST =
  "UPDATE_BILLING_SUBSCRIPTION_REQUEST";
export const UPDATE_BILLING_SUBSCRIPTION_SUCCESS =
  "UPDATE_BILLING_SUBSCRIPTION_SUCCESS";
export const UPDATE_BILLING_SUBSCRIPTION_FAIL =
  "UPDATE_BILLING_SUBSCRIPTION_FAIL";
export const RESET_UPDATE_BILLING_SUBSCRIPTION =
  "RESET_UPDATE_BILLING_SUBSCRIPTION";

export const ADD_CASE_TO_SUBSCRIPTION_REQUEST =
  "ADD_CASE_TO_SUBSCRIPTION_REQUEST";
export const ADD_CASE_TO_SUBSCRIPTION_SUCCESS =
  "ADD_CASE_TO_SUBSCRIPTION_SUCCESS";
export const ADD_CASE_TO_SUBSCRIPTION_FAIL = "ADD_CASE_TO_SUBSCRIPTION_FAIL";
export const RESET_ADD_CASE_TO_SUBSCRIPTION = "RESET_ADD_CASE_TO_SUBSCRIPTION";

export const REMOVE_CASE_TO_SUBSCRIPTION_REQUEST =
  "REMOVE_CASE_TO_SUBSCRIPTION_REQUEST";
export const REMOVE_CASE_TO_SUBSCRIPTION_SUCCESS =
  "REMOVE_CASE_TO_SUBSCRIPTION_SUCCESS";
export const REMOVE_CASE_TO_SUBSCRIPTION_FAIL =
  "REMOVE_CASE_TO_SUBSCRIPTION_FAIL";
export const RESET_REMOVE_CASE_TO_SUBSCRIPTION =
  "RESET_REMOVE_CASE_TO_SUBSCRIPTION";

export const CANCEL_SUBSCRIPTION_REQUEST = "CANCEL_SUBSCRIPTION_REQUEST";
export const CANCEL_SUBSCRIPTION_SUCCESS = "CANCEL_SUBSCRIPTION_SUCCESS";
export const CANCEL_SUBSCRIPTION_FAIL = "CANCEL_SUBSCRIPTION_FAIL";
export const RESET_CANCEL_SUBSCRIPTION = "RESET_CANCEL_SUBSCRIPTION";
